import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card } from "react-bootstrap";
import { getUserInitial } from "../../../../utils/otherHelopers";
import { TabCard } from "../../../../components/custom-card/Cards";
import UserNetworkingModal from "../../../../components/modals/UserNetworkingModal";
import { routes } from "../../../../routes/pageRoutes";

const Overview = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { companyDetail } = useSelector((state) => state.company);

  const [showNetworkingModal, setShowNetworkingModal] = useState(false);
  const [networkingType, setNetworkingType] = useState("");

  const handleCardClick = (key) => {
    if (key === "followers") {
      setNetworkingType("companyFollowers");
      setShowNetworkingModal(true);
    } else if (key === "posts") {
      const updated = new URLSearchParams(searchParams);
      updated.set("tab", "posts");
      setSearchParams(updated);
    } else if (key === "products") {
      const updated = new URLSearchParams(searchParams);
      updated.set("tab", "profile");
      updated.set("profile-tabs", "products");
      setSearchParams(updated);
    } else if (key === "bulk-offers") {
      navigate(routes.marketplaceBulkOffers);
    }
  };

  const cardData = [
    {
      key: "followers",
      title: "Followers",
      count: companyDetail?.followers_count || 0,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="19" y1="8" x2="19" y2="14" />
          <line x1="16" y1="11" x2="22" y2="11" />
        </svg>
      ),
      bg: "#fff7ed",
      color: "#f97316"
    },
    {
      key: "posts",
      title: "Posts",
      count: companyDetail?.total_posts || 0,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
      bg: "#faf5ff",
      color: "#a855f7"
    },
    {
      key: "products",
      title: "Products",
      count: companyDetail?.products?.length || 0,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      ),
      bg: "#f0fdf4",
      color: "#22c55e"
    },
    {
      key: "bulk-offers",
      title: "Bulk Offer",
      count: companyDetail?.bulk_offers_count || 0,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
      ),
      bg: "#ecfeff",
      color: "#06b6d4"
    }
  ];

  const bioRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [companyDetail?.profile?.about]);

  useEffect(() => {
    const checkOverflow = () => {
      if (!isExpanded && bioRef.current) {
        const hasOverflow = bioRef.current.scrollHeight > bioRef.current.clientHeight;
        setIsClamped(hasOverflow);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [companyDetail?.profile?.about, isExpanded]);

  const handleViewAllVerifications = (e) => {
    e.preventDefault();
    const updated = new URLSearchParams(searchParams);
    updated.set("tab", "verifications");
    setSearchParams(updated);
  };


  return (
    <div className="overview-tab">
      <div className="grid gap-3 mb-3 mt-4" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
        {cardData.map((card) => (
          <TabCard
            key={card.key}
            title={card.title}
            count={card.count}
            onClick={() => handleCardClick(card.key)}
            icon={card.icon}
            iconBg={card.bg}
            iconColor={card.color}
          />
        ))}
      </div>

      <div className="grid gap-3 mt-4 align-items-start">
        {/* Card 1: About Card */}
        <Card className="overview-details-card g-col-4 border-0 shadow-sm">
          <Card.Body className="p-4 d-flex flex-column h-100">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5 className="overview-details-card-title fw-bold mb-0">About</h5>

            </div>
            <p
              ref={bioRef}
              className={`overview-details-bio text-muted ${!isExpanded ? "collapsed" : ""} ${isClamped ? "has-toggle" : ""
                }`}
              style={{ whiteSpace: "pre-line" }}
            >
              {companyDetail?.profile?.about || "No description available."}
            </p>
            {isClamped && (
              <button
                type="button"
                className="bio-toggle-btn"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? "Show less" : "Show more"}
              </button>
            )}
            <div className="overview-details-list flex-grow-1">
              <div className="overview-details-row">
                <span className="overview-details-label">Category</span>
                <span className="overview-details-value text-dark">
                  {companyDetail?.category?.name || "-"}
                </span>
              </div>
              <div className="overview-details-row">
                <span className="overview-details-label">Phone</span>
                <span className="overview-details-value text-dark">
                  {companyDetail?.profile?.mobile_number || "-"}
                </span>
              </div>
              <div className="overview-details-row">
                <span className="overview-details-label">Whatsapp</span>
                <span className="overview-details-value text-dark">
                  {companyDetail?.profile?.whatsapp_number || "-"}
                </span>
              </div>
              <div className="overview-details-row">
                <span className="overview-details-label">Email</span>
                <span className="overview-details-value text-dark text-break">
                  {companyDetail?.profile?.email || "-"}
                </span>
              </div>
              <div className="overview-details-row">
                <span className="overview-details-label">Website</span>
                <span className="overview-details-value">
                  {companyDetail?.profile?.website ? (
                    <a
                      href={companyDetail.profile.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="overview-details-link text-break"
                    >
                      {companyDetail.profile.website}
                    </a>
                  ) : (
                    "-"
                  )}
                </span>
              </div>
              <div className="overview-details-row">
                <span className="overview-details-label">Address</span>
                <span className="overview-details-value text-dark text-break">
                  {companyDetail?.profile?.address || "-"}
                </span>
              </div>
              <div className="overview-details-row">
                <span className="overview-details-label">City</span>
                <span className="overview-details-value text-dark">
                  {companyDetail?.profile?.city?.name || "-"}
                </span>
              </div>
              <div className="overview-details-row">
                <span className="overview-details-label">State</span>
                <span className="overview-details-value text-dark">
                  {companyDetail?.profile?.city?.state?.name || "-"}
                </span>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Card 2: Company Owner Card */}
        <Card className="overview-details-card g-col-4 border-0 shadow-sm">
          <Card.Body className="p-4 d-flex flex-column h-100">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5 className="overview-details-card-title fw-bold mb-0">Company Owner</h5>
            </div>
            {companyDetail?.creator ? (
              <div className="d-flex flex-column align-items-center text-center gap-3 w-100">
                <div
                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-semibold shadow-sm cursor-pointer"
                  style={{ width: "80px", height: "80px", fontSize: "24px" }}
                  onClick={() => navigate(`/user/user-detail/${companyDetail?.creator?.id}`)}
                >
                  {companyDetail?.creator?.profile?.profile_photo?.url ? (
                    <img
                      src={companyDetail.creator.profile.profile_photo.url}
                      alt="creator"
                      className="w-100 h-100 object-fit-cover rounded-circle"
                    />
                  ) : (
                    getUserInitial(
                      `${companyDetail?.creator?.first_name} ${companyDetail?.creator?.last_name || ""}`
                    )
                  )}
                </div>
                <div className="w-100 px-3">
                  <h6
                    className="fw-bold text-primary cursor-pointer mb-2"
                    style={{ fontSize: "16px" }}
                    onClick={() => navigate(`/user/user-detail/${companyDetail?.creator?.id}`)}
                  >
                    {companyDetail?.creator?.first_name} {companyDetail?.creator?.last_name || ""}
                  </h6>
                  <div className="overview-details-list mt-3">
                    <div className="overview-details-row justify-content-between">
                      <span className="overview-details-label text-start" style={{ width: "auto" }}>
                        Phone
                      </span>
                      <span className="overview-details-value text-dark text-end">
                        {companyDetail.creator.mobile_number || "-"}
                      </span>
                    </div>
                    <div className="overview-details-row justify-content-between">
                      <span className="overview-details-label text-start" style={{ width: "auto" }}>
                        Email
                      </span>
                      <span className="overview-details-value text-dark text-end text-break">
                        {companyDetail.creator.email || "-"}
                      </span>
                    </div>
                    <div className="overview-details-row justify-content-between">
                      <span className="overview-details-label text-start" style={{ width: "auto" }}>
                        Profession
                      </span>
                      <span className="overview-details-value text-dark text-end">
                        {companyDetail.creator.profile?.profession?.name || "-"}
                      </span>
                    </div>
                    <div className="overview-details-row justify-content-between">
                      <span className="overview-details-label text-start" style={{ width: "auto" }}>
                        City
                      </span>
                      <span className="overview-details-value text-dark text-end">
                        {companyDetail.creator.profile?.city?.name || "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-muted text-center py-5 small">No owner details available.</div>
            )}
          </Card.Body>
        </Card>

        {/* Card 3: Verification Summary Card */}
        <Card className="overview-details-card g-col-4 border-0 shadow-sm">
          <Card.Body className="p-4 d-flex flex-column h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h5 className="overview-details-card-title fw-bold mb-0">Verification Summary</h5>
              <a
                href="#view-all-verifications"
                className="overview-details-view-all-link fw-semibold"
                onClick={handleViewAllVerifications}
              >
                View All
              </a>
            </div>
            <div className="verification-rows-container flex-grow-1 user-details-page">
              <div className="overview-tab m-0 p-0 shadow-none border-0 bg-transparent">
                <div className="verification-row py-2">
                  <span className="verification-label small">Email Verification</span>
                  <div className={`verification-value-wrapper ${companyDetail?.creator?.is_email_verified ? "text-success" : "text-danger"}`}>
                    <span className="fw-semibold me-1" style={{ fontSize: "12px" }}>
                      {companyDetail?.creator?.is_email_verified ? "Verified" : "Not Verified"}
                    </span>
                    {companyDetail?.creator?.is_email_verified ? (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-success">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="16 9 11 14 8 11" />
                      </svg>
                    ) : (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                      </svg>
                    )}
                  </div>
                </div>
                <div className="verification-row py-2">
                  <span className="verification-label small">Mobile Verification</span>
                  <div className={`verification-value-wrapper ${companyDetail?.creator?.is_mobile_verified ? "text-success" : "text-danger"}`}>
                    <span className="fw-semibold me-1" style={{ fontSize: "12px" }}>
                      {companyDetail?.creator?.is_mobile_verified ? "Verified" : "Not Verified"}
                    </span>
                    {companyDetail?.creator?.is_mobile_verified ? (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-success">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="16 9 11 14 8 11" />
                      </svg>
                    ) : (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                      </svg>
                    )}
                  </div>
                </div>
                <div className="verification-row py-2">
                  <span className="verification-label small">Verification Status</span>
                  <div className={`verification-value-wrapper ${companyDetail?.is_verified ? "text-success" : "text-danger"}`}>
                    <span className="fw-semibold me-1" style={{ fontSize: "12px" }}>
                      {companyDetail?.is_verified ? "Verified" : "Not Verified"}
                    </span>
                    {companyDetail?.is_verified ? (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-success">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="16 9 11 14 8 11" />
                      </svg>
                    ) : (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* User Networking Modal */}
      <UserNetworkingModal
        isOpen={showNetworkingModal}
        onClose={() => setShowNetworkingModal(false)}
        userId={companyDetail?.id}
        type={networkingType}
        className="networking-modal"
      />
    </div>
  );
};

export default Overview;
